import experiments from '../../common/constants/experiments'

export default {
  name: 'AudioJungle',
  abbreviation: 'AJ',
  domain: 'audiojungle.net',
  google_analytics_id: 'UA-11834194-4',
  google_remarketing_label: 'SQ7NCLWBugMQp-WC_AM',
  item_results_layout: 'list',
  home_search_placeholder: 'e.g. ambient music',
  assets_domains: {
    item_thumbnail: 'thumb-aj.s3.envato.com',
    item_image: 'image-aj.s3.envato.com'
  },
  features: {
    /**
     * @description Is true, we collapse the tags filter for all category pages unless it's a bottom level category (no children)
     * @author Geoff Evason
     * @expires Never.  This is currently used by some markets and not others.
     */
    'collapse-tags-unless-bottom-category': true,

    /**
     * @description Decide whether to display v0 or v1 item cards in search results page.
     *   Should be removed when all markets will use v1 item card.
     * @author Pawel Galazka
     * @expires
     * @expires When all markets will use v1 item card
     */
    'v0-search-results': false,

    /**
     * @description Decide wether to show the new features in AJ item Cards
          Including preview download / track length tooltips / new feature indicator
     * @author Pawel Galazka & Javed de Costa
     * @expires At the end of AJ Phase 2
     */
    audioJungleItemCardFeatures: false,

    /**
     * @description Decide wether to show the volume slider for AJ
     * @author Pawel Galazka & Javed de Costa
     * @expires At the end of AJ Phase 2
     */
    audioJungleVolumeSlider: false,

    /**
     * @description Turns on enrolment for users into the AJ Phase 2 experiment,
           which includes the Item Card features and the new volume slider
     * @author Pawel Galazka & Javed de Costa
     * @expires At the end of AJ Phase 2
     */
    'audioJungleNewPreviewFeatures:enrolment': true
  },
  experiments_to_features: {
    [experiments.audioJungleNewPreviewFeatures]: {
      0: {
        audioJungleItemCardFeatures: false,
        audioJungleVolumeSlider: false
      },
      1: {
        audioJungleItemCardFeatures: false,
        audioJungleVolumeSlider: false
      },
      2: {
        audioJungleItemCardFeatures: true,
        audioJungleVolumeSlider: true
      },
      3: {
        audioJungleItemCardFeatures: true,
        audioJungleVolumeSlider: true
      }
    }
  }
}
